import { render, staticRenderFns } from "./ServicesSinglePage.vue?vue&type=template&id=077f2278&scoped=true&"
import script from "./ServicesSinglePage.vue?vue&type=script&lang=js&"
export * from "./ServicesSinglePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077f2278",
  null
  
)

export default component.exports